import { render } from "./AssetClassesPage.vue?vue&type=template&id=72f13ed7"
import script from "./AssetClassesPage.vue?vue&type=script&lang=js"
export * from "./AssetClassesPage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/cmtycoin.xyz/repo/frontend-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__